// Tracking Constants
export var TRACK_PAGE_VIEWED = 'pageview';
export var TRACK_EVENT = 'event';